import { FQTmplQuestionAnswerOptions } from 'Components/ComponentLibrary/Organisms/FQTmplQuestionAnswerOptions';
import { buildFacetDesignFilterFormOverride } from 'Packages/FacetRest/FacetDesignFilterFormOverride';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { AutoCompleteInputLarge } from 'Packages/FacetDesign/Components';

export default buildFacetDesignFilterFormOverride()
  .overrideAll({
    _customProps: {
      fullWidth: true,
    },
  })
  .nameOverride('questionAnswerOptions', {
    _component: () => FQTmplQuestionAnswerOptions,
    _spreadPropNames: ['resource', 'attrName'],
  }, overrideReadOnly)
  .typeOverride('picklist', {
    _component: () => AutoCompleteInputLarge,
    _spreadPropNames: ['helperText'],
    _customProps: {
      fullWidth: true,
    },
  }, overrideReadOnly);
